import React from "react";
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'motion/react';
import Leagues from '../pages/Leagues';
import League from '../pages/League';
import Seasons from '../pages/Seasons';
import Season from '../pages/Season';
import Stage from '../pages/Stage';
import Player from '../pages/Player';
import Login from '../pages/Login';
import Ranking from '../pages/Ranking';
import Tournaments from '../pages/Tournaments';
import Tournament from '../pages/Tournament';
import Rulebook from '../pages/Rulebook';
import Byes from '../pages/Byes';
import Home from '../pages/Home';
import { AuthCallback } from 'casdoor-react-sdk';
import * as Settings from '../utils/AuthUtils';

function PublicRoutes(props) {
    const location = useLocation();
    const authCallback = (
        <AuthCallback
            sdk={Settings.casdoorSDK}
            serverUrl={Settings.appServerUrl}
            saveTokenFromResponse={(res) => {
              // save token
              setTimeout(() => {
                Settings.setToken(res?.payLoad.accessToken);
                Settings.goToLink("/");
              }, '1500');
              
            }}
            isGetTokenSuccessful={(res) => {
              // according to the data returned by the server,
              // determine whether the `token` is successfully obtained through `code` and `state`.
              // console.warn('stato di res in isGetTokenSuccessful:', res);
              return res.errorMsg === '';          
            }}
          />
      );

    return (
        <AnimatePresence>
            <Routes basename={props.basepath} location={location} key={location.pathname}>
                <Route path="/tournaments" element={<Tournaments />} />
                <Route path="/tournaments/:id" element={<Tournament hasRights={props.hasRights} />} />
                <Route path="/rankings" element={<Ranking />} />
                <Route path="/leagues" element={<Leagues />} />
                <Route path="/leagues/:id" element={<League />} />
                <Route path="/seasons" element={<Seasons />} />
                <Route path="/seasons/:id" element={<Season />} />
                <Route path="/stages/:id" element={<Stage />} />
                <Route path="/players/:id" element={<Player />} />
                <Route path="/rulebook" element={<Rulebook />} />
                <Route path="/byes" element={<Byes />} />
                <Route path="/login" element={<Login />} />
                <Route path="/callback" element={authCallback} />
                <Route path="/home" element={<Home />} />
                <Route path="*" element={<Navigate to="/home" />} />
            </Routes>
        </AnimatePresence>
    )
}

export default PublicRoutes;